import React from 'react';

export default function Tentang(){
  return (
    <main style={{padding:16}}>
      <h1>Tentang</h1>
      <p>Tentang klinik kami.</p>
    </main>
  );
}
